export default __webpack_public_path__ + "static/media/photosAdultRight.9146f37c.png";